import { LocationItem } from '../Card';
import React from 'react';

import { TransportationItemsFragment } from '../../generated/graphql';
import { transportationItemRoute } from '../../helpers/routes';
import { ItemProps } from './common';
import { resizeImageW } from '../../helpers/mediaApiUrls';
import { PageItemLink } from '../PageItemLink';

const Transportation: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  const transport = item as TransportationItemsFragment;
  const photoPath = resizeImageW(transport.photo?.mediaUrl, 145);

  return (
    <PageItemLink
      to={transportationItemRoute(page.id, transport.id, preview)}
      page={page}
      pageItem={item}
      data-testid={`transportation-item-${transport.id}`}
    >
      <LocationItem
        header="Transport"
        name={transport.name}
        address={transport.address}
        description={transport.description}
        website={transport.website}
        phone={transport.phone}
        photoPath={photoPath}
        email={transport.email}
        className={className}
        {...dragProps}
      />
    </PageItemLink>
  );
};

export default Transportation;
